export default __webpack_public_path__ + "static/media/_DUA5007.2a3cbfa3.jpg";